import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from './CalendarTime.module.scss';

const CalendarTime = (props) => {
  const {
    endTime,
    formattedEndDate,
    formattedStartDate,
    isAllDay,
    isFirstDay,
    isLastDay,
    showUpcomingMsg,
    startTime,
    targetDay,
    timeBarClass,
    upcomingTime
  } = props;

  const timeBarClasses = [classes.timeBar, timeBarClass].join(' ');

  if (isAllDay) {
    if (!targetDay) {
      return (
        <div className={timeBarClasses}>
          {formattedStartDate && <div>{formattedStartDate}</div>}
          {formattedEndDate && <div>
            <span className={classes.divider}>–</span>
            {formattedEndDate}
          </div>}
        </div>
      );
    }

    return (
      <div className={timeBarClasses}>
        <FormattedMessage
          id="components.calendarEvent.allDay"
          defaultMessage="All Day"
        />
        {upcomingTime && showUpcomingMsg &&
          <div className={classes.upcomingTime}>
            {upcomingTime}
          </div>}
      </div>
    );
  }

  return (
    <div className={timeBarClasses}>
      <div>
        {!isLastDay && startTime}
      </div>
      {endTime && !isFirstDay && <div>
        {isLastDay ?
          <FormattedMessage
            id="components.calendarEvent.until"
            defaultMessage="Until {endTime}"
            values={{
              endTime
            }}
          />
          :
          <div>
            <span className={classes.divider}>–</span>
            {endTime}
          </div>
        }
      </div>}
      {upcomingTime && showUpcomingMsg && <div className={classes.upcomingTime}>
        {upcomingTime}
      </div>}
    </div>
  );
};

CalendarTime.propTypes = {
  endTime: PT.string,
  formattedEndDate: PT.string,
  formattedStartDate: PT.string,
  isAllDay: PT.bool,
  isFirstDay: PT.bool,
  isLastDay: PT.bool,
  showUpcomingMsg: PT.bool,
  startTime: PT.string,
  targetDay: PT.object,
  timeBarClass: PT.string,
  upcomingTime: PT.string
};

export default CalendarTime;
